import React from "react";
import { Col, Row } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";

const BankInformation = ({ control }) => {
  return (
    <Row gutter={[32, 20]}>
      <Col span={12}>
        <Controller
          name="account_holder_name"
          control={control}
          render={({
            field: { onChange, value },
            fieldState: { error },
          }) => (
            <CustomTextfield
              id="account_holder_name"
              label="Account Holder Name"
              showOptional
              labelColor="#171717"
              placeholder="Enter name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>
      <Col span={12}>
        <Controller
          name="bank_name"
          control={control}
          render={({
            field: { onChange, value },
            fieldState: { error },
          }) => (
            <CustomTextfield
              id="bank_name"
              label="Bank Name"
              showOptional
              labelColor="#171717"
              placeholder="Enter bank name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>
      <Col span={12}>
        <Controller
          name="bank_account_number"
          control={control}
          render={({
            field: { onChange, value },
            fieldState: { error },
          }) => (
            <CustomTextfield
              id="bank_account_number"
              label="Bank Account number"
              showOptional
              labelColor="#171717"
              placeholder="Enter account number"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>
      <Col span={12}>
        <Controller
          name="branch_code"
          control={control}
          render={({
            field: { onChange, value },
            fieldState: { error },
          }) => (
            <CustomTextfield
              id="branch_code"
              label="Branch Code"
              showOptional
              labelColor="#171717"
              placeholder="Enter branch code"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default BankInformation;
